module.exports = __webpack_public_path__ + "../resources/images/emptyFlaggedEmailTaskList-d03ce46bfb455f1598c73f4bcb70efd6.svg";